import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { get_recently_assigned_assessment_kits_list_candidate_action } from "../../../redux/_actions/candidate";

function useViewInterviewVideos(props) {
  const [loading, setLoading] = useState(false);
  const [assignedAssessmentKitsList, setAssignedAssessmentKitsList] = useState(
    []
  );

  //pagination
  const [nextPage, setNextPage] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [lastElement, setLastElement] = useState(null);
  const [newKitsLoading, setNewKitsLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { assignedAssessmentKitsListData } = useSelector(
    (state) =>
      state.get_recently_assigned_assessment_kits_list_candidate_reducer
  );

  useEffect(() => {
    setLoading(true);
    callApi();
  }, []);

  useEffect(() => {
    if (assignedAssessmentKitsListData?.data) {
      setAssignedAssessmentKitsList(assignedAssessmentKitsListData?.data);
    }
  }, [assignedAssessmentKitsListData]);

  useEffect(() => {
    if (nextPage !== null) {
      setNewKitsLoading(true);
      callApi();
    }
  }, [pageNum]);

  // useEffect(() => {
  //   if (assignedAssessmentKitsData?.data) {
  //     let data = assignedAssessmentKitsData.data?.results;
  //     let results = assignedAssessmentKits;
  //     data.forEach((newItem) => {
  //       if (!results.find((item) => item.id === newItem.id)) {
  //         results.push(newItem);
  //       }
  //     });
  //     setAssignedAssessmentKits(results);
  //     setNextPage(assignedAssessmentKitsData?.data.next);
  //   }
  // }, [assignedAssessmentKitsData]);

  //infinite scroll pagination
  useEffect(() => {
    const currentElement = lastElement;
    const currentObserver = observer.current;

    if (currentElement) {
      currentObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  }, [lastElement]);

  const observer = useRef(
    new IntersectionObserver((entries) => {
      const first = entries[0];
      if (first.isIntersecting) {
        setPageNum((no) => no + 1);
      }
    })
  );

  const callApi = async () => {
    await dispatch(
      get_recently_assigned_assessment_kits_list_candidate_action()
    );
    setLoading(false);
    setNewKitsLoading(false);
  };

  const onAcceptInterviewClick = (interviewKit, jobPosting) => {
    navigate(
      `/assigned-interview-kit?appliedJob=${jobPosting}&interviewKit=${interviewKit}`
    );
  };

  const countTime = (data) => {
    let total_time = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        element?.questions &&
          element.questions.forEach((time) => (total_time = time + total_time));
      });
    return total_time;
  };

  const countQuestions = (data) => {
    let total_question = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        total_question =
          Array.isArray(element?.questions && element) &&
          element?.questions &&
          element.questions.length + total_question;
      });
    return total_question;
  };

  return {
    loading,
    assignedAssessmentKitsList,
    assignedAssessmentKitsListData,
    setLastElement,
    onAcceptInterviewClick,
    countTime,
    countQuestions,
  };
}
export default useViewInterviewVideos;
